import { getSiteSettings } from '../etc/utils';
import { Container, Service } from './container';
export class Config extends Service {
    getSiteSettings() {
        return getSiteSettings();
    }
}
Container.add(Config);
